import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/common/PrivateRoute';
import Header from './components/common/Header';
import Sidebar from './components/common/Sidebar';
import Layout from './components/common/Layout';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import TaskManagement from './pages/TaskManagement';
import QuranTracker from './pages/QuranTracker';
import StatsPage from './pages/StatsPage';
import UserProfile from './pages/UserProfile';
import AdminDashboard from './pages/AdminDashboard';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import LandingPage from './pages/LandingPage';

import { DailyActionsProvider } from './context/DailyActionsContext';
import { ThemeProvider } from './context/ThemeContext';

function App() {
    return (
        <AuthProvider>
            <ThemeProvider>
                <DailyActionsProvider>
                    <Router>
                        <Routes>
                            {/* Public Routes */}
                            <Route path="/landing" element={<LandingPage />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/forgot-password" element={<ForgotPassword />} />
                            <Route path="/reset-password/:token" element={<ResetPassword />} />
                            <Route path="/register/:token" element={<Register />} />

                            {/* Private Routes */}
                            <Route path="/" element={<PrivateRoute />}>
                                <Route element={<Layout />}>
                                    <Route index element={<Dashboard />} />
                                    <Route path="dashboard" element={<Dashboard />} />
                                    <Route path="tasks" element={<TaskManagement />} />
                                    <Route path="quran" element={<QuranTracker />} />
                                    <Route path="stats" element={<StatsPage />} />
                                    <Route path="profile" element={<UserProfile />} />
                                    <Route path="admin" element={<AdminDashboard />} />
                                </Route>
                            </Route>

                            {/* Catch all */}
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </Router>
                </DailyActionsProvider>
            </ThemeProvider>
        </AuthProvider>
    );
}

export default App;
